import React from 'react';
import { CTAButton } from './ui/CTAButton';
export function FAQSection() {
  return <section className="w-full py-16 bg-[#EAF6FF]" data-id="element-149">
      <div className="max-w-3xl mx-auto px-4" data-id="element-150">
        <h2 className="text-3xl md:text-4xl font-black text-center mb-12 text-gray-900" data-id="element-151">
          ❓ Preguntas frecuentes
        </h2>

        <div className="space-y-6 mb-16" data-id="element-152">
          <div className="bg-gray-50 p-6 rounded-xl border border-gray-200" data-id="element-153">
            <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-154">
              ¿Para qué edades es este material?
            </h3>
            <p className="text-gray-700" data-id="element-155">
              Está diseñado para niños entre 3 y 6 años.
            </p>
          </div>

          <div className="bg-gray-50 p-6 rounded-xl border border-gray-200" data-id="element-156">
            <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-157">
              ¿El material es digital o físico?
            </h3>
            <p className="text-gray-700" data-id="element-158">
              Es 100% digital. Puedes descargarlo e imprimir las actividades.
            </p>
          </div>

          <div className="bg-gray-50 p-6 rounded-xl border border-gray-200" data-id="element-159">
            <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-160">
              ¿Necesito conocimientos educativos para usarlo?
            </h3>
            <p className="text-gray-700" data-id="element-161">
              No. Las actividades están diseñadas para que cualquier padre o
              madre pueda aplicarlas fácilmente.
            </p>
          </div>

          <div className="bg-gray-50 p-6 rounded-xl border border-gray-200" data-id="element-162">
            <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-163">
              ¿Puedo usarlo varias veces?
            </h3>
            <p className="text-gray-700" data-id="element-164">
              Sí. Puedes imprimir las actividades cuantas veces quieras.
            </p>
          </div>
        </div>

        <div className="text-center bg-blue-50 p-8 rounded-2xl border border-blue-100" data-id="element-165">
          <h3 className="text-2xl md:text-3xl font-black text-blue-900 mb-6" data-id="element-166">
            Estimular el aprendizaje de tu hijo puede ser más simple
          </h3>

          <div className="text-lg text-gray-700 space-y-2 mb-8 font-medium" data-id="element-167">
            <p data-id="element-168">No necesitas ser docente.</p>
            <p data-id="element-169">No necesitas actividades complicadas.</p>
            <p data-id="element-170">
              Solo necesitas las herramientas adecuadas para aprender jugando.
            </p>
          </div>

          <CTAButton text="👉 Accede ahora al Mega Pack Actividades para Niños" data-id="element-171" />

          <p className="mt-8 text-gray-600 italic font-medium max-w-xl mx-auto" data-id="element-172">
            Porque los niños no solo necesitan entretenimiento… necesitan
            estímulo para desarrollar su mente mientras se divierten. 🎨📚
          </p>
        </div>
      </div>
    </section>;
}